var _path, _path2, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckCertified(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.161 12.0256L18.161 12.0255C19.2796 10.9069 19.2797 9.09314 18.161 7.97447L17.4562 7.26966C17.294 7.10751 17.2029 6.88762 17.2029 6.65833V5.6616C17.2029 4.07959 15.9205 2.79706 14.3384 2.79706H13.3417C13.1124 2.79706 12.8925 2.70599 12.7303 2.54383L12.0256 1.83904C12.0255 1.83904 12.0255 1.83903 12.0255 1.83903C10.9069 0.720324 9.09311 0.720325 7.97444 1.83903C7.97444 1.83903 7.97443 1.83904 7.97443 1.83904L7.26964 2.54383C7.10748 2.70599 6.8876 2.79706 6.6583 2.79706H5.66157C4.07957 2.79706 2.79704 4.07954 2.79704 5.6616V6.65833C2.79704 6.88762 2.70596 7.10751 2.54381 7.26966L1.839 7.97447L1.83899 7.97448C0.720346 9.09317 0.720324 10.9069 1.839 12.0256L2.54611 11.3185L1.839 12.0256L2.54381 12.7304C2.70596 12.8925 2.79704 13.1124 2.79704 13.3417V14.3384C2.79704 15.9204 4.07951 17.203 5.66157 17.203H6.6583C6.88759 17.203 7.10748 17.294 7.26964 17.4562L7.97444 18.161L7.97446 18.161C9.09315 19.2797 10.9069 19.2797 12.0255 18.161L12.7303 17.4562C12.8925 17.294 13.1124 17.203 13.3417 17.203H14.3384C15.9204 17.203 17.2029 15.9205 17.2029 14.3384V13.3417C17.2029 13.1124 17.294 12.8925 17.4562 12.7304L18.161 12.0256Z",
    fill: "#4F95CC",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6206 14.7811C10.7571 13.7168 10.0244 12.5667 9.46655 11.3135C9.16799 10.6428 8.90053 9.95904 8.67958 9.25877C8.49756 8.6819 8.34764 8.09502 8.18616 7.51216C7.83451 6.24288 7.5176 4.9737 7.34318 3.66669C7.12713 3.75203 6.89509 3.79704 6.6583 3.79704H5.66157C4.63181 3.79704 3.79704 4.63184 3.79704 5.66157V6.6583C3.79704 7.15282 3.6006 7.62706 3.25091 7.97674L2.54611 8.68155C1.81796 9.40969 1.81796 10.5903 2.54611 11.3184L3.25091 12.0232C3.6006 12.3729 3.79704 12.8472 3.79704 13.3417V14.3384C3.79704 15.3682 4.63184 16.2029 5.66157 16.2029H6.6583C7.15282 16.2029 7.62706 16.3994 7.97674 16.7491L8.68155 17.4539C9.40969 18.182 10.5903 18.182 11.3184 17.4539L12.0232 16.7491C12.2925 16.4798 12.6357 16.3014 13.0051 16.2336C12.5169 15.7767 12.0401 15.2983 11.6206 14.7811Z",
    fill: "#337EB6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_143_4561",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 10,
    height: 10
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 10,
    height: 10,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_143_4561)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.92368 12.7778C9.51889 13.1657 8.87626 13.1605 8.47789 12.7621L5.88821 10.1724C5.48453 9.76876 5.48453 9.11427 5.88821 8.71059C6.29188 8.30692 6.94637 8.30692 7.35004 8.7106L9.21502 10.5756L12.6104 7.18017C13.0141 6.77649 13.6686 6.77649 14.0723 7.18017C14.4759 7.58384 14.4759 8.23833 14.0723 8.642L10.0271 12.6872C9.9942 12.7201 9.95964 12.7503 9.92368 12.7778Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCertified);
export default __webpack_public_path__ + "static/media/check-certified.083c9596ed6194bdced84db8911e1331.svg";
export { ForwardRef as ReactComponent };